// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-01-24 02:54:28 +0100 (Sat, 24 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159989 $
//  Purpose   : fulltext package
// =============================================================================
import * as reducers from './reducers';
export { reducers };
import * as actions from './actions';
export { actions };
import * as views from './views';
export { views };
export const parts = true;
export const columns = true;
export const templates = true;
export const jobs = true;
// VLM access
export const selectors = {
    fulltextAdminShowViewer: (root)=>root.ui.byId['Part/FulltextEditor/FulltextAdminOptions'].value.showViewer
};
